<template>
    <span>
         <span  v-show="enabled">
             <slot :scope="scope"></slot>
         </span>
         <span style="display:inline-block;margin-left:20px;" v-for="doc in docs" v-bind:key="doc.DOCUMENT_ID">
            <a target="blank" class="fileinput-filename" :title="doc.S_ORIGINAL_NAME" @click="getFile(doc.src)"
                style="color:blue;cursor:pointer;display: inline-block;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;max-width:120px" v-text="doc.S_ORIGINAL_NAME"></a>
             <a  class="fileclose" v-show="enabled" title="删除文件" style="font-size: 21px;color: red; margin-top: -20px;cursor:pointer" @click="deleteFile(doc.DOCUMENT_ID)">×</a>
        </span>
     </span>
</template>
<script>
import "../../../static/plugin/plupload/queue/css/jquery.plupload.queue.css";
import "../../../static/plugin/plupload/plupload.js"
import "../../../static/plugin/plupload/queue/jquery.plupload.queue.js"
import "../../../static/plugin/plupload/plupload.html4.js"
import "../../../static/plugin/plupload/plupload.html5.js"
import "../../../static/plugin/plupload/plupload.flash.js"
import "../../../static/plugin/plupload/zh_CN.js"
export default {
    name: 'LayuiFileUpload',
    props: {
        requestUniqueId: {
            type: String, // // 请求唯一标识，必须有
            default: () => {
                return 'LayuiFileUpload-' + window.uuid();
            },
        },
        _model: {
            default: '',
            required: false
        },
        enabled: {
            type: Boolean,
            default: ()=>{
                return true;
            }
        },
        uploadTitle: {
            type: String,
        },
        filters: {
            type: Array,
            default: ()=> {
                return []
            }
        },
        max : {
            type: Number,
            default : -1
        },
        businessTable: {
            type: String,
            required : true
        },
        businessField: {
            type: String,
            required : true
        }
    },
    model: {
        prop: '_model',
        event: '_modelEvent'
    },
    data() {
        return {
            id: null,
            scope: this,
            fileNum: 0,
            docs : []
        }
    },
    mounted() {
        var element = this.el = $(this.$el);
        var id = this.id = this.uuid();
        this.tid = this.security.getUser().getF_token();
        this.url = process.env.API_HOST+'/xmjc/file/upload/' + this.tid;
    },
    methods: {
        upload() {
            if(this.fileNum == this.max) {
                this.layer.openAlert("只允许上传" + this.max + "个文件!");
                return;
            }
            var that = this;
            $("#" + this.id).remove();
            this.el.find('.layuiupload').attr("id", this.id);
            var uploadEl = this.getUploadTemplate();
            uploadEl = $(uploadEl);
            uploadEl.attr('id', this.id);
            $("body").append(uploadEl);
            this.layer.openPop(this.id, this.uploadTitle ? this.uploadTitle : '上传', null, 380, true);
            uploadEl.find(".filePlace").pluploadQueue({
                runtimes : 'html5,flash',
                url : that.url,
                unique_names : true,
                filters : this.filters.length > 0 ? [{title : "", extensions : this.filters.join(",")}] : "",
                init:{
                    FileUploaded: function(uploader,file,response){
                        if(response.response){
                            var result = JSON.parse(response.response);
                            
                            console.log(result);
                            if(result.error) {
                                console.error(result.error);
                            } else {
                                that.layer.openAlert(result.result.msg);
                                var addDoc = result.doc;
                                var obj = {};
                                for(var p in addDoc) {
                                    obj[p.toUpperCase()] = addDoc[p];
                                }
                                that.fileNum ++;
                                that.docs.push(that.wrapDoc(obj));
                                that.ui_update = true;
                                that.$emit('_modelEvent', that.buildValue());
                            }
                            that.layer.closePop(that.id)
                        }
                    },
                    UploadComplete: function(uploader,fs){
                        uploader.refresh();
                        uploader.destroy();//ie9以下若不销毁此对象第二次上传会十分缓慢
                    },
                    FilesAdded: function(uploader, files){
                        if(that.max > 0 && that.fileNum + uploader.files.length > that.max) {
                            while(uploader.files.length > 0){
                                uploader.removeFile(uploader.files[0]);
                            }
                            that.layer.openAlert("只允许上传" + that.max + "个文件!");
                            return;
                        }
                    },
                }
            });
        },
        getUploadTemplate() {
            return `<div class="layuiupload"style="display: none;">
                        <div class="filePlace"></div>
                        </div>
                    </div>`
        },
        deleteFile(docId){
             this.layer.openConfirm('确定要删除这个文件吗?', ()=> {
                for(var i = 0 ; i < this.docs.length; i ++) {
                    var doc = this.docs[i];
                    if(doc.DOCUMENT_ID == docId){
                        this.docs.remove(doc);
                        this.ui_update = true;
                        this.$emit('_modelEvent', this.buildValue());
                        return;
                    }
                }
            });
        },
        buildValue(){
            var value = [];
            for(var i = 0 ; i < this.docs.length; i ++) {
                var doc = this.docs[i];
                value.push(doc.DOCUMENT_ID);
            }
            return value.join(",");
        },
        setValue(value) {
            if(!this.ui_update) {
                if(!value) {
                    this.docs = [];
                } else {
                    this.api.queryList(
                            'DB_DOCUMENT', 
                            {p2: {'DOCUMENT_ID:1': value}},
                            this.requestUniqueId
                    ).then(response => {
                        var results = response.result;
                        for(var i = 0; i < results.length; i++) {
                            var result = results[i];
                            if(!this.containsDoc(result.DOCUMENT_ID)) {
                                this.docs.push(this.wrapDoc(result));
                            }
                        }
                        this.fileNum = results.length;
                    });
                }
            }
            this.ui_update = false;
            this.fileNum = this.docs.length;
        },
        containsDoc(docId) {
            for(var i = 0 ; i < this.docs.length; i ++) {
                var doc = this.docs[i];
                if(doc.DOCUMENT_ID == docId) {
                    return true;
                }
            }
        },
        wrapDoc(doc) {
            doc.src = process.env.REPOSITORY_HOST + '/file/get/' + doc.DOCUMENT_ID + '/' + this.tid;
            return doc;
        },
        getFile(docId) {
            window.open(docId);
        }
    },
    watch:{
        _model(value){
           this.setValue(value);
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/common/LayuiFileUploadData.vue